export default __webpack_public_path__ + "static/media/sanJoseImage.34377900.svg";